(() => {
  const SELECTOR = "[data-enso-record-ledger]";

  const keepToggleInPlace = (toggle, update) => {
    const previousTop = toggle.getBoundingClientRect().top;
    update();

    window.requestAnimationFrame(() => {
      const nextTop = toggle.getBoundingClientRect().top;
      const delta = nextTop - previousTop;

      if (Math.abs(delta) < 1) return;

      const root = document.documentElement;
      const previousBehavior = root.style.scrollBehavior;
      root.style.scrollBehavior = "auto";
      window.scrollBy(0, delta);
      root.style.scrollBehavior = previousBehavior;
    });
  };

  const initializeLedger = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.ledgerReady === "true") {
      return;
    }

    const items = Array.from(root.querySelectorAll("[data-ledger-item]"));
    const toggle = root.querySelector("[data-ledger-toggle]");

    if (!(toggle instanceof HTMLButtonElement) || items.length === 0) return;

    const requestedPreviewCount = Number.parseInt(root.dataset.ledgerPreviewCount || "6", 10);
    const previewCount = Number.isFinite(requestedPreviewCount)
      ? Math.min(Math.max(requestedPreviewCount, 1), items.length)
      : Math.min(6, items.length);
    const featured = items.filter((item) => item.dataset.ledgerFeatured === "true");
    const previewItems = [];

    featured.slice(0, previewCount).forEach((item) => previewItems.push(item));

    items.forEach((item) => {
      if (previewItems.length >= previewCount || previewItems.includes(item)) return;
      previewItems.push(item);
    });

    items.forEach((item) => {
      item.dataset.ledgerPreview = previewItems.includes(item) ? "true" : "false";
    });

    const label = toggle.querySelector("[data-ledger-toggle-label]");
    const count = toggle.querySelector("[data-ledger-toggle-count]");
    const icon = toggle.querySelector("[data-ledger-toggle-icon]");
    const openLabel = toggle.dataset.openLabel || "VIEW FULL RECORD";
    const closeLabel = toggle.dataset.closeLabel || "CLOSE RECORD";

    const setExpanded = (expanded) => {
      root.dataset.ledgerExpanded = expanded ? "true" : "false";
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");

      if (label) label.textContent = expanded ? closeLabel : openLabel;
      if (count) count.textContent = expanded ? "" : `· ${items.length}`;
      if (icon) icon.textContent = expanded ? "−" : "+";

      toggle.setAttribute(
        "aria-label",
        expanded ? closeLabel : `${openLabel} · ${items.length}`
      );
    };

    root.dataset.ledgerReady = "true";
    root.dataset.ledgerEnhanced = "true";

    if (items.length <= previewCount) {
      root.dataset.ledgerExpanded = "true";
      return;
    }

    toggle.hidden = false;
    setExpanded(false);

    toggle.addEventListener("click", () => {
      const expanded = root.dataset.ledgerExpanded === "true";

      if (expanded) {
        keepToggleInPlace(toggle, () => setExpanded(false));
      } else {
        setExpanded(true);
      }
    });
  };

  const initializeAll = (scope = document) => {
    if (scope instanceof HTMLElement && scope.matches(SELECTOR)) {
      initializeLedger(scope);
    }

    scope.querySelectorAll?.(SELECTOR).forEach(initializeLedger);
  };

  if (!window.EnsoRecordLedger) {
    window.EnsoRecordLedger = { initializeAll };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener("shopify:section:load", (event) => {
      initializeAll(event.target);
    });

    document.addEventListener("shopify:block:select", (event) => {
      const item = event.target.closest?.("[data-ledger-item]");
      const root = item?.closest(SELECTOR);
      const toggle = root?.querySelector("[data-ledger-toggle]");

      if (!root || !(toggle instanceof HTMLButtonElement) || toggle.hidden) return;
      if (root.dataset.ledgerExpanded === "true") return;

      toggle.click();
    });
  } else {
    window.EnsoRecordLedger.initializeAll();
  }
})();
